import React from 'react';
import './Navigation.css';

const NAV_ITEMS = [
  { href: '#hero',        label: './v8',       testId: 'nav-home' },
  { href: '#identity',    label: 'Identity',   testId: 'nav-identity' },
  { href: '#domains',     label: 'Vectors',    testId: 'nav-domains' },
  { href: '#signal',      label: 'Signal',     testId: 'nav-signal' },
  { href: '#coordinates', label: 'Coordinates',testId: 'nav-coordinates' },
];

const Navigation = ({ show }) => {
  const scrollToSection = (e, id) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`navigation ${show ? 'show' : ''}`}
      data-testid="navigation"
      aria-label="Site navigation"
    >
      <div className="nav-content">
        {NAV_ITEMS.map(({ href, label, testId }) => (
          <a
            key={href}
            href={href}
            onClick={(e) => scrollToSection(e, href.slice(1))}
            data-testid={testId}
          >
            {label}
          </a>
        ))}
      </div>
    </nav>
  );
};

export default Navigation;
